
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMessageIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21 1.5H3A2.503 2.503 0 0 0 .5 4v11A2.503 2.503 0 0 0 3 17.5h1v3.978a1.016 1.016 0 0 0 .634.95.98.98 0 0 0 1.08-.236l4.5-4.692H21a2.503 2.503 0 0 0 2.5-2.5V4A2.503 2.503 0 0 0 21 1.5zM22.5 15a1.502 1.502 0 0 1-1.5 1.5H10a.499.499 0 0 0-.36.154L5 21.478V17a.5.5 0 0 0-.5-.5H3A1.502 1.502 0 0 1 1.5 15V4A1.502 1.502 0 0 1 3 2.5h18A1.502 1.502 0 0 1 22.5 4v11z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.538 6.309A.5.5 0 0 0 5 7h5a.5.5 0 0 0 0-1H5a.5.5 0 0 0-.462.309zm10.924 6.382A.5.5 0 0 0 15 12H5a.5.5 0 0 0 0 1h10a.5.5 0 0 0 .462-.309zm2-3A.5.5 0 0 0 17 9H5a.5.5 0 1 0 0 1h12a.5.5 0 0 0 .462-.309z",
  fill: "#000"
})));

      const __svgRaw = "<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>\r\n      <path\r\n        d='M21 1.5H3A2.503 2.503 0 0 0 .5 4v11A2.503 2.503 0 0 0 3 17.5h1v3.978a1.016 1.016 0 0 0 .634.95.98.98 0 0 0 1.08-.236l4.5-4.692H21a2.503 2.503 0 0 0 2.5-2.5V4A2.503 2.503 0 0 0 21 1.5zM22.5 15a1.502 1.502 0 0 1-1.5 1.5H10a.499.499 0 0 0-.36.154L5 21.478V17a.5.5 0 0 0-.5-.5H3A1.502 1.502 0 0 1 1.5 15V4A1.502 1.502 0 0 1 3 2.5h18A1.502 1.502 0 0 1 22.5 4v11z'\r\n        fill='#000'\r\n      />\r\n      <path\r\n        d='M4.538 6.309A.5.5 0 0 0 5 7h5a.5.5 0 0 0 0-1H5a.5.5 0 0 0-.462.309zM15.462 12.691A.5.5 0 0 0 15 12H5a.5.5 0 0 0 0 1h10a.5.5 0 0 0 .462-.309zM17.462 9.691A.5.5 0 0 0 17 9H5a.5.5 0 1 0 0 1h12a.5.5 0 0 0 .462-.309z'\r\n        fill='#000'\r\n      />\r\n    </svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/message-icon.8e121dc746029f98eb82cb59687be6a9.svg"),
        {
          React: SvgMessageIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      